import { Component, Inject, OnInit, ViewChild , EventEmitter} from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_807';

const stepsList = [ 
  { text: "1", active: true, completed: false, tooltip: 'renta hotelera', listHelp: ['714'] },

];
@Component({
  selector: 'app-renta-no-laboral-otros-ingresos-modal',
  templateUrl: './renta-no-laboral-otros-ingresos-modal.component.html',
  styleUrls: ['./renta-no-laboral-otros-ingresos-modal.component.css'],
})
export class RentaNoLaboralOtrosIngresosModalComponent extends HandlerModal implements OnInit {

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave:boolean;
  
  constructor(
    public dialogRef: MatDialogRef<RentaNoLaboralOtrosIngresosModalComponent>,
    public dutilidades:DOperacionesMatematicasServicio,  
    public dNotificacionServicio: DNotificacionServicio,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }
 
  ngOnInit() {
    this.inicializeModelo();
    this.validateShowSave();
  }
  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cs_id_714 == undefined)this.model.doc.cuerpo.cs_id_714="0";
    if(this.model.doc.cuerpo.cs_id_807 == undefined)this.model.doc.cuerpo.cs_id_807="0";
    
  }

  //////////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {
    console.log(this.indexStepper + " - " +val);
    switch (this.indexStepper) {
      case 4:
        if(val == "0"){
          if(this.validateHasModalValues(this.indexStepper)){
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_793 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          }else{
            this.model.doc.cuerpo.cs_id_793 = val;
          }
        }else{
          this.model.doc.cuerpo.cs_id_793 = val;
        }

        //Si ha seleccionado respuesta SI/NO habilitar botón next
        if(val!=undefined && val!=""){
          this.buttonRight.nativeElement.disabled = false;
        }
        break;

      case 7:
        if(val == "0"){
          if(this.validateHasModalValues(this.indexStepper)){
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_761 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          }else{
            this.model.doc.cuerpo.cs_id_761 = val;
          }
        }else{
          this.model.doc.cuerpo.cs_id_761 = val;
        }

        //Si ha seleccionado respuesta SI/NO habilitar botón next
        if(val!=undefined && val!=""){
          this.buttonRight.nativeElement.disabled = false;
        }
        break;

      
      case 9:
        if(val == "0"){
          if(this.validateHasModalValues(this.indexStepper)){
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_757 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          }else{
            this.model.doc.cuerpo.cs_id_757 = val;
          }
        }else{
          this.model.doc.cuerpo.cs_id_757 = val;
        }

        //Si ha seleccionado respuesta SI/NO habilitar botón next
        if(val!=undefined && val!=""){
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
    }
    console.log(this.model);
  }

  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
  
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    this.model.doc.cuerpo.cs_id_714="0";
    this.model.doc.cuerpo.cs_id_807="0";
    
    console.log(this.model);
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
 
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){
    //Si no se ha seleccionado respuesta SI/NO en go15CasaNacional deshabilitar botón next
   
  }
  


  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
    let indexS = this.indexStepper;
    while(!this.validateStepHabilitado(indexS)){
      if(direction==DirectionType.previous ){
          indexS--;
      }
      if(direction==DirectionType.next){
          indexS++;
      }
    }
    this.changeStepLocal(indexS, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }

  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
     
      case 714:
        this.OperacionCs714();
        break;
     
   }
    if(soloEstaCasilla)return;

    //Operaciones
    let resultado = "0";
    
  }

  //valor otros ingresos
OperacionCs714() {
	//no tiene validaciones
 }


  public closeModal(){
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }
  public guardar(){
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1){
      this.closeModal();
    }
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/renta-no-laboral/renta-no-laboral-otros-ingresos-modal/renta-no-laboral-otros-ingresos-modal.component.ts